import styled from 'styled-components';

import { Subtitle2 } from '@estee/elc-typography';
import { ContentSpacing, breakpoint } from '@estee/elc-base-theme';

import { inheritBaseFont } from '~theme/default-theme';

import { IEmphasis } from '~theme/IEmphasis';

export const TotalPrice = styled(Subtitle2)`
    ${inheritBaseFont};
`;

export const PriceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;
    flex-direction: row-reverse;
`;

export const FreeItemLabel = styled(Subtitle2)`
    ${inheritBaseFont};
`;

export const FreeSampleItemLabel = styled(Subtitle2)`
    order: 1;
    display: flex;
    font-weight: 700;
    ${inheritBaseFont};
`;

export const Container = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row;
    padding-top: ${ContentSpacing.space2};
`;

export const PriceItemWrapper = styled.div`
    order: 1;
    display: flex;
    align-items: center;
    ${breakpoint('desktop')`
        margin: 0;
    `};
`;

export const TotalPriceItemWrapper = styled.div`
    order: 0;
    display: flex;
    align-items: center;
    ${breakpoint('desktop')`
        margin: 0;
    `};
`;

export const Price = styled(Subtitle2)`
    ${inheritBaseFont};
`;

export const DiscountedPrice = styled(Subtitle2)`
    display: inline-block;
    padding: 0 ${ContentSpacing.space2};

    ${inheritBaseFont};
`;

export const OldPrice = styled(Subtitle2)<IEmphasis>`
    display: inline-block;
    text-decoration: line-through;
    opacity: 0.4;
    padding: 0 ${ContentSpacing.space2};
    ${inheritBaseFont};
`;

export const PercentDiscount = styled(Subtitle2)<IEmphasis>`
    display: inline-block;
    opacity: 0.4;
    font-style: italic;
    padding: 0 ${ContentSpacing.space2};
    ::before {
        content: '(-';
    }
    ::after {
        content: ')';
    }

    ${inheritBaseFont};
`;
